"use client";

import { ActionCard } from "@/components/ActionCard";
import { Bell, ArrowDown, Mail } from "lucide-react";

export function AlertsCard() {
  const header = (
    <div className="mb-4 w-full aspect-[16/9] rounded-lg border border-border/60 bg-muted/10 flex flex-col items-center justify-center p-4 overflow-hidden relative">
      {/* Background pulse rings */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="absolute h-32 w-32 rounded-full bg-red-500/5 animate-ping" style={{ animationDuration: '3s' }} />
        <div className="absolute h-24 w-24 rounded-full bg-red-500/10 animate-ping" style={{ animationDuration: '3s', animationDelay: '0.5s' }} />
      </div>

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center gap-3">
        {/* Bell with notification badge */}
        <div className="relative">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-red-500/20 to-orange-500/20 border border-red-500/30">
            <Bell className="h-6 w-6 text-red-500 animate-[wiggle_1s_ease-in-out_infinite]" />
          </div>
          {/* Notification dot */}
          <div className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-red-500 flex items-center justify-center animate-pulse">
            <span className="text-[9px] font-bold text-white">1</span>
          </div>
        </div>

        {/* Arrow animation */}
        <ArrowDown className="h-4 w-4 text-muted-foreground/50 animate-bounce" />

        {/* Email notification card - slides in */}
        <div className="w-full max-w-[200px] animate-[slideUp_0.5s_ease-out_forwards]">
          <div className="rounded-lg border border-border bg-background shadow-lg overflow-hidden">
            {/* Email header */}
            <div className="bg-muted/50 px-3 py-1.5 border-b border-border/50 flex items-center gap-2">
              <Mail className="h-3 w-3 text-muted-foreground" />
              <span className="text-[10px] text-muted-foreground">New Alert</span>
            </div>
            {/* Email content */}
            <div className="p-3">
              <div className="text-[11px] font-semibold text-foreground">
                Score dropped
              </div>
              <div className="mt-1 flex items-center gap-2">
                <span className="text-[18px] font-bold text-muted-foreground">78</span>
                <span className="text-muted-foreground/50">→</span>
                <span className="text-[18px] font-bold text-red-500">72</span>
              </div>
              <div className="mt-1.5 text-[10px] text-muted-foreground/70">
                example.com
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom keyframes */}
      <style jsx>{`
        @keyframes wiggle {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-10deg); }
          75% { transform: rotate(10deg); }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );

  return (
    <ActionCard
      ariaLabel="Instant alerts"
      title="Instant alerts"
      subtitle="Get notified the moment something breaks. We email you when your score drops so you can fix issues fast."
      header={header}
    />
  );
}
